import { Auth } from "aws-amplify";
import { Storage } from 'aws-amplify';
import { v4 as uuid_v4 } from "uuid";

const handleUpload = async (payload: any) => {
  const {
    file,
    fileName,
    streamType
  } = payload;

  const fileId = uuid_v4();
  if (streamType === "YOUTUBE" || streamType === "VIMEO") {
    const fileKey = `uploads/${fileId}`;
    return await uploadToS3(fileId, fileKey, " ", payload);
  } else {
    const fileKey = `uploads/${fileId}-${fileName}`;
    return await uploadToS3(fileId, fileKey, file, payload);
  }
};

const uploadToS3 = async (fileId: any, fileKey: string, file: any, payload: any) => {
  const {
    sessionCode,
    sortOrder,
    tenantId,
    stimulusType,
    streamType,
    stimulusAlias,
    stimulusDescription
  } = payload;

  try {
    const currentUser = await Auth.currentUserInfo();

    return await Storage.put(fileKey, file, {
      progressCallback() {
        //
      },
      level: 'private',
      metadata: {
        FileId: fileId,
        SessionCode: sessionCode,
        SortOrder: sortOrder,
        TenantId: tenantId,
        StimulusType: stimulusType,
        StreamType: streamType,
        StimulusAlias: stimulusAlias,
        StimulusDescription: stimulusDescription,
        Email: currentUser.attributes.email,
        UserName: currentUser.username
      }
    });
  } catch (e) {

  }

};

const handleCopyFile = async (payload: any) => {
  const {
    file,
    fileName,
    streamType
  } = payload;
  const fileId = uuid_v4();
  if (streamType === "YOUTUBE" || streamType === "VIMEO") {
    const fileKey = `uploads/${fileId}`;
    return await uploadToCopyS3(fileId, fileKey, " ", payload);
  } else {
    const fileKey = `uploads/${fileId}-${fileName}`;
    return await uploadToCopyS3(fileId, fileKey, file, payload);
  }
};

const uploadToCopyS3 = async (fileId: any, fileKey: string, file: any, payload: any) => {
  const {
    sessionCode,
    sortOrder,
    tenantId,
    stimulusType,
    streamType,
    stimulusAlias,
    stimulusDescription,
    operation,
    sourceId
  } = payload;

  try {
    const currentUser = await Auth.currentUserInfo();

    return await Storage.put(fileKey, file, {
      progressCallback() {
        //
      },
      level: 'private',
      metadata: {
        FileId: fileId,
        SessionCode: sessionCode,
        SortOrder: sortOrder,
        TenantId: tenantId,
        StimulusType: stimulusType,
        StreamType: streamType,
        StimulusAlias: stimulusAlias,
        StimulusDescription: stimulusDescription,
        Email: currentUser.attributes.email,
        UserName: currentUser.username,
        Operation: operation ? operation : "",
        Sourceid: sourceId ? sourceId : ""
      }
    });
  } catch (e) {

  }
};

export {
  handleUpload,
  handleCopyFile
}